module.exports = __webpack_public_path__ + "static/img/default.dfd86cd.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/default.jpeg
// module id = KChL
// module chunks = 1